import React, {useContext} from 'react';
import {SearchContext} from "./index";

const ShowingListings = () => {
    const {
        setSearchState,
        searchState,
    } = useContext(SearchContext)

    return (
        <span className="small">
            <span>Showing Listings</span>
            <select
                className="margin5 noborder"
                onChange={({target: {value}}) => {
                    setSearchState({
                        ...searchState,
                        search_obj: {
                            ...searchState.search_obj,
                            page_count: value,
                            page_num: 1,
                            upcoming_page_num: 1
                        }
                    })
                }}
                value={searchState?.search_obj?.page_count}
            >
                <option value={15}>15</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
            </select>
        </span>
    );
};

export default ShowingListings;
